export const stringCollator = Intl.Collator(undefined, { sensitivity: 'base' });
